<template>
    <div ref="menstruation" class="menstruation-warp" v-show="show">
        <div class="symptom-list-wrapper">
            <div class="symptom-list">
                <div class="list-title">婚姻情况</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in maritalStatusList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
            <div class="symptom-list">
                <div class="list-title">生育情况</div>
                <div class="list-item">
                    <el-popover ref="pregnancyPopover" popper-class="pregnancy-popover" placement="top-start" title="怀孕次数" width="106"
                        trigger="click">
                        <div slot="reference" class="item-warp hover-eff3f6">孕 <span>{{pregnant.pregnancyNum}}</span> <i class="el-icon-caret-bottom"></i></div>
                        <ul>
                            <li class="pregnancy-num-warp hover-eff3f6" v-for="item in pregnancyNumList" :key="item" @click="pregnancyNumClick(item)">{{item }}</li>
                        </ul>
                    </el-popover>
                    <el-popover ref="childbirthPopover" popper-class="pregnancy-popover" placement="top-start" title="生产次数" width="106"
                        trigger="click">
                        <div slot="reference" class="item-warp hover-eff3f6">产 <span>{{pregnant.childbirthNum}}</span> <i class="el-icon-caret-bottom"></i></div>
                        <ul>
                            <li class="pregnancy-num-warp hover-eff3f6" v-for="item in childbirthNumList" :key="item" @click="childbirthNumClick(item)">{{item }}</li>
                        </ul>
                    </el-popover>
                    <el-button type="text" @click="birthConfirm">输入</el-button>
                </div>
            </div>
            <div class="border-line"></div>
            <div class="symptom-list align-i-c">
                <div class="list-title">月经情况</div>
                <div class="list-item">
                    <el-popover ref="menarcheAgePopover" popper-class="pregnancy-popover" placement="top-start" title="初潮年龄" width="106"
                        trigger="click">
                        <div slot="reference" class="item-warp hover-eff3f6">{{menstruation.menarcheAge}} <i class="el-icon-caret-bottom"></i></div>
                        <ul>
                            <li class="pregnancy-num-warp hover-eff3f6" v-for="item in menarcheAgeList" :key="item" @click="menarcheAgeClick(item)">{{item }}</li>
                        </ul>
                    </el-popover>
                    <div class="menstruation-info">
                        <div class="tac hover-eff3f6">
                            <el-popover ref="menstruationDaysPopover" popper-class="pregnancy-popover" placement="top-start" title="行经天数" width="106" trigger="click">
                            <div slot="reference" class="item-warp hover-eff3f6">{{menstruation.menstruationDays | filterArrar }} <i class="el-icon-caret-bottom"></i></div>
                            <ul>
                                <li class="pregnancy-num-warp hover-eff3f6" v-for="item in menstruationDaysList" :key="item" @click="menstruationDaysClick(item)">{{item }}</li>
                            </ul>
                        </el-popover>
                        </div>
                        <div class="cut-line"></div>
                        <div class="tac hover-eff3f6">
                            <el-popover ref="menstrualCyclePopover" popper-class="pregnancy-popover" placement="top-start" title="月经周期" width="254" trigger="click">
                                <div slot="reference" class="item-warp ">{{menstruation.menstrualCycle | filterArrar }} <i class="el-icon-caret-bottom"></i></div>
                                <ul>
                                    <li class="pregnancy-num-warp hover-eff3f6" v-for="item in menstrualCycleList" :key="item" @click="menstrualCycleClick(item)">{{item }}</li>
                                </ul>
                            </el-popover>
                        </div>
                        
                    </div>
                    <el-date-picker class="ml8" v-model="menstruation.menopauseDate" value-format="yyyy-MM-dd" clearable align="right" type="date" placeholder="末次月经日期"></el-date-picker>
                    <el-popover ref="menopauseAgePopover" popper-class="pregnancy-popover" placement="top-start" title="绝经年龄" width="164"
                        trigger="click">
                        <div slot="reference" placeholder="绝经年龄" class="item-warp hover-eff3f6">{{menstruation.menopauseAge || '绝经年龄'}} <i @click="menstruation.menopauseAge=null" :class="menstruation.menopauseAge?'el-icon-circle-close':'el-icon-caret-bottom'"></i></div>
                        <ul>
                            <li class="pregnancy-num-warp hover-eff3f6" v-for="item in menopauseAgeList" :key="item" @click="menopauseAgeClick(item)">{{item }}</li>
                        </ul>
                    </el-popover>
                    <el-button type="text" @click="menstruationConfirm">输入</el-button>
                </div>
            </div>
            <div class="border-line"></div>
            <div class="symptom-list">
                <div class="list-title">经量色质</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)"  v-for="item in menstrualVolumeList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
            <div class="symptom-list">
                <div class="list-title">白带情况</div>
                <div class="list-item">
                    <div class="item-warp hover-c6e2ff" @click="addItem(item.label)" v-for="item in leukorrheaList" :key="item.value">{{item.label }}</div>
                </div>
            </div>
        </div>
        <div class="close-suggestions" @click="close">
            <i class="el-icon-circle-close mr8 size16"></i>
            关闭
        </div>
    </div>
</template>

<script>
import { isEmptyArray, isArray, isObject, isNull } from '../utils/validateBase'
import moment from 'moment/moment'
export default {
    props: {
        show: {
            type: Boolean,
            default: false
        },
        menstrualHistory: {
            type: Array | String,
            default: function(){return []}
        },
    },
    data() {
        return {
            maritalStatusList: [
                { value: '1', label: '未婚' },
                { value: '2', label: '已婚未育' },
                { value: '3', label: '已婚已育' },
                { value: '4', label: '适龄婚育' },
                { value: '5', label: '配偶体健' },
                { value: '6', label: '离异' },
                { value: '7', label: '丧偶' },
            ],
            pregnant:{
                pregnancyNum: 1,//怀孕次数
                childbirthNum: 1,//生产次数
            },//生育情况对象
            menstruation:{
                menarcheAge: 13,//初潮年龄
                menstruationDays:[3,5],//行经天数
                menstrualCycle:[28,30],//月经周期
                menopauseDate:moment().subtract(1,'days').format('YYYY-MM-DD'),//末次月经日期
                menopauseAge:null,//绝经年龄
            },//月经情况对象
            pregnancyNumList: [0, 1, 2, 3, 4, 5, 6, 7, 8,], //怀孕次数列表
            childbirthNumList: [0, 1, 2, 3, 4, 5, 6, 7, 8,], //生产次数列表
            menarcheAgeList: [10,11, 12, 13, 14, 15, 16, 17, 18,],//初潮年龄列表
            menstruationDaysList: [2,3, 4, 5, 6, 7, 8, 9,10],//行经天数列表
            menstrualCycleList: [21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60],//月经周期列表
            menopauseAgeList: [41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60],//绝经列表
            menstrualVolumeList:[
                {value:'1',label:'经量正常'},
                {value:'2',label:'量多'},
                {value:'3',label:'量少'},
                {value:'4',label:'闭经'},
                {value:'5',label:'经色正常'},
                {value:'6',label:'色淡红'},
                {value:'7',label:'色鲜红'},
                {value:'8',label:'色深红'},
                {value:'9',label:'色紫暗'},
                {value:'10',label:'经质正常'},
                {value:'11',label:'质稀'},
                {value:'12',label:'质稠'},
                {value:'13',label:'夹有血块'},
                {value:'14',label:'痛经'},
                {value:'15',label:'无痛经'},
                {value:'16',label:'绝经'},
            ],
            leukorrheaList:[
                {value:'1',label:'白带正常'},
                {value:'2',label:'白带量多'},
                {value:'3',label:'白带质稀'},
                {value:'4',label:'白带质稠'},
                {value:'5',label:'白带异味'},
                {value:'6',label:'白带色黄'},
                {value:'7',label:'白带色灰'},
                {value:'8',label:'脓性白带'},
                {value:'9',label:'血色白带'},
                {value:'10',label:'水样白带'},
                {value:'11',label:'豆渣样白带'},
                {value:'12',label:'泡沫状白带'},
            ],
            // menstrualHistory:[],
        }
    },
    filters:{
        filterArrar(val){
            let str = ''
            if(!isEmptyArray(val)){
                if(val.length==1){
                    str = val[0]
                }else if(val.length==2){
                    str = `${val[0]}~${val[1]}`
                }
            }
            return str;
        }
    },
    methods:{
        //初始化数据
        initData(){
            this.pregnant={
                pregnancyNum: 1,//怀孕次数
                childbirthNum: 1,//生产次数
            }
            this.menstruation={
                menarcheAge: 13,//初潮年龄
                menstruationDays:[3,5],//行经天数
                menstrualCycle:[28,30],//月经周期
                menopauseDate:this.$moment().subtract(1,'days').format('YYYY-MM-DD'),//末次月经日期
                menopauseAge:null,//绝经年龄
            }
        },
        //点击怀孕次数
        pregnancyNumClick(item){
            this.pregnant.pregnancyNum=item;
            this.$refs.pregnancyPopover.doClose();
        },  
        //点击生产次数
        childbirthNumClick(item){
            this.pregnant.childbirthNum=item;
            this.$refs.childbirthPopover.doClose();
        },  
        //点击初潮年龄
        menarcheAgeClick(item){
            this.menstruation.menarcheAge=item;
            this.$refs.menarcheAgePopover.doClose();
        },  
        //点击绝经年龄
        menopauseAgeClick(item){
            this.menstruation.menopauseAge=item;
            this.$refs.menopauseAgePopover.doClose();
        },  
        //点击行经天数
        menstruationDaysClick(item){
            if(!isEmptyArray(this.menstruation.menstruationDays) && this.menstruation.menstruationDays.length==2){
                this.menstruation.menstruationDays=[];
                this.menstruation.menstruationDays[0]=item;
            }else if(!isEmptyArray(this.menstruation.menstruationDays && this.menstruation.menstruationDays.length==1)){
                this.menstruation.menstruationDays.push(item);
                this.menstruation.menstruationDays.sort((a,b)=>{
                    return a-b;
                })
                this.$refs.menstruationDaysPopover.doClose();
            }
        },
        //点击月经周期
        menstrualCycleClick(item){
            if(!isEmptyArray(this.menstruation.menstrualCycle) && this.menstruation.menstrualCycle.length==2){
                this.menstruation.menstrualCycle=[];
                this.menstruation.menstrualCycle[0]=item;
            }else if(!isEmptyArray(this.menstruation.menstrualCycle && this.menstruation.menstrualCycle.length==1)){
                this.menstruation.menstrualCycle.push(item);
                this.menstruation.menstrualCycle.sort((a,b)=>{
                    return a-b;
                })
                this.$refs.menstrualCyclePopover.doClose();
            }
        },
        //添加每项内容
        addItem(item){
            if(!this.menstrualHistory.includes(item)){
                this.menstrualHistory.push({type:'text',text:item});
            }
            this.$emit('menstrualHistoryChange',this.menstrualHistory)
        },
        //生育情况确定
        birthConfirm(){
            let flag = this.menstrualHistory.some(val=>{ return isObject(val) && val.type=='pregnant' })
            if(flag){
                let item = this.menstrualHistory.find(val=>{ return isObject(val) && val.type=='pregnant' })
                for(let key in item){
                    for(let key2 in this.pregnant){
                        if(key == key2){
                        item[key] = this.pregnant[key2]
                    }
                    }
                }
                item.text=`孕${item.pregnancyNum} 产${item.childbirthNum}`
            }else{
                let obj ={}
                obj.type='pregnant'
                obj.pregnancyNum=this.pregnant.pregnancyNum
                obj.childbirthNum=this.pregnant.childbirthNum
                obj.text=`孕${this.pregnant.pregnancyNum} 产${this.pregnant.childbirthNum}`
                this.menstrualHistory.push(obj)
            }
            this.$emit('menstrualHistoryChange',this.menstrualHistory)
        },
        //月经情况确定
        menstruationConfirm(){
            let flag = this.menstrualHistory.some(val=>{ return isObject(val) && val.type=='menstruation' })
            if(flag){
                let item = this.menstrualHistory.find(val=>{ return isObject(val) && val.type=='menstruation' })
                for(let key in item){
                   for(let key2 in this.menstruation){
                    if(key == key2){
                        item[key] = this.menstruation[key2]
                    }
                   }
                }
                item.text=`${item.menarcheAge} (${item.menstruationDays.length==1? item.menstruationDays[0]:`${item.menstruationDays[0]}~${item.menstruationDays[1]}`})/(${item.menstrualCycle.length==1? item.menstrualCycle[0]:`${item.menstrualCycle[0]}~${item.menstrualCycle[1]}`}) ${!isNull(item.menopauseDate)?item.menopauseDate:''} ${!isNull(item.menopauseAge)?item.menopauseAge:''}`

            }else{
                let obj ={}
                obj.type = 'menstruation'
                obj.menarcheAge=this.menstruation.menarcheAge
                obj.menstruationDays=this.menstruation.menstruationDays
                obj.menstrualCycle=this.menstruation.menstrualCycle
                obj.menopauseDate=this.menstruation.menopauseDate
                obj.menopauseAge=this.menstruation.menopauseAge
                obj.text=`${this.menstruation.menarcheAge} (${this.menstruation.menstruationDays.length==1? this.menstruation.menstruationDays[0]:`${this.menstruation.menstruationDays[0]}~${this.menstruation.menstruationDays[1]}`})/(${this.menstruation.menstrualCycle.length==1? this.menstruation.menstrualCycle[0]:`${this.menstruation.menstrualCycle[0]}~${this.menstruation.menstrualCycle[1]}`}) ${!isNull(this.menstruation.menopauseDate)?this.menstruation.menopauseDate:''} ${!isNull(this.menstruation.menopauseAge)?this.menstruation.menopauseAge:''}`
                this.menstrualHistory.push(obj)
            }
            this.$emit('menstrualHistoryChange',this.menstrualHistory)
        },
        close(){
            this.$emit('close')
        }

    }
}
</script>
<style lang="less">
.pregnancy-popover {
    min-width: 100px;
    padding: 6px;
    box-sizing: border-box;

    .el-popover__title {
        font-size: 12px;
        margin-bottom: 6px;
        text-align: center;
    }

    .pregnancy-num-warp {
        align-items: center;
        border-radius: 4px;
        color: #474747;
        cursor: pointer;
        display: inline-flex;
        font-size: 12px;
        height: 28px;
        justify-content: center;
        margin: 1px;
        width: 28px;
    }

    .hover-eff3f6 {
        &:hover {
            background-color: #eff3f6;
        }
    }
}
</style>
<style lang="less" scoped>
.hover-c6e2ff {
    &:hover {
        background-color: #c6e2ff;
        color: #0090ff
    }
}

.hover-eff3f6 {
    &:hover {
        background-color: #eff3f6;
    }
}

.menstruation-warp {
    background-color: #fff;
    border: 1px solid #b7b9c2;
    border-radius: 4px;
    font-size: 14px;
    left: 180px;
    min-width: 400px;
    position: absolute;
    width: 650px;
    z-index: 1009;
    bottom: -320px;
    .border-line{
        background-color: #dadbe0;
        font-size: 0;
        height: 1px;
        margin: 0 8px
    }
    
    .symptom-list-wrapper {
        padding: 0 7px;

        .symptom-list {
            display: flex;
            margin: 8px 0;
            padding: 0;

            .list-title {
                font-weight: 700;
                line-height: 1;
                margin: 0;
                min-width: 74px;
                padding: 5px 8px;
            }

            .list-item {
                display: flex;
                margin-bottom: 2px;
                align-items: center;
                flex-wrap: wrap;
                .item-warp {
                    border-radius: 4px;
                    color: #7a8794;
                    cursor: pointer;
                    display: inline-block;
                    line-height: 1;
                    padding: 5px 8px;
                    user-select: none;
                    white-space: nowrap;
                }
                .menstruation-info{
                    display: inline-flex;
                    flex-direction: column;
                    width: 72px;
                    .cut-line{
                        border-bottom-color: #e0e2eb;
                        height: 1px;
                        width: 100%;
                        background-color: #dadbe0;
                        font-size: 0;
                    }
                }
                .el-date-editor{
                    width: 110px;
                    cursor: pointer;
                    /deep/.el-input__inner{
                        font-size: 14px;
                        border-radius: 4px;
                        color: #7a8794;
                        padding: 5px 8px;
                        // padding-right: 0;
                        border-color: transparent;
                        &:hover{
                            background-color: #eff3f6;
                        }
                    }
                }
                /deep/.el-input__prefix{
                    display: none
                }


            }
        }
        
    }
    .close-suggestions{
        align-items: center;
        background: #f7f7f7;
        border-radius: 0 0 4px 4px;
        color: #005ed9;
        cursor: pointer;
        display: flex;
        font-weight: 500;
        height: 40px;
        justify-content: center;
        line-height: 40px;
        position: relative;
        width: 100%;
    }
}
</style>